import { ref, computed } from "vue";
import { defineStore } from "pinia";

/**
 * The Navbar pinia store is used to show and hide the navbar depending on the current page. This store is used in
 * conjunction with vue router to show and hide the navbar based on the navbarEnabled meta tag that is added
 * to routes.
 *
 * For more information please review the routing section of the docs
 */
export const useNavbarStore = defineStore("x-navbar", () => {
    const isNavbarEnabled = ref<boolean>(true);

    return {
        isNavbarEnabled: computed<boolean>(() => isNavbarEnabled.value),

        /**
         * Allows you to show and hide the navbar at the top of the page.
         * @param isEnabled true to show the navbar, false to hide it
         */
        enableNavbar: (isEnabled: boolean = true): void => { isNavbarEnabled.value = isEnabled }
    };
});
